import { render, staticRenderFns } from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=template&id=d2d54be6&scoped=true"
import script from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=script&lang=ts"
export * from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d54be6",
  null
  
)

export default component.exports